<template>
  <div
    class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 p-6"
  >
    <div
      v-for="device in wholeDevices"
      :key="device.deviceType"
      class="flex flex-col justify-between bg-gray-800 rounded-2xl overflow-hidden transition-transform hover:scale-105"
    >
      <WatchfaceInfoItem :device="device" :get-shape-label="getShapeLabel" />
    </div>
  </div>
</template>
<script lang="ts" setup>
import {
  useWatchfaceDevices,
  watchfaceShapeOptions
} from '@/hooks/use-watchface-devices';

const { wholeDevices } = useWatchfaceDevices();

const getShapeLabel = (shape: string) => {
  const option = watchfaceShapeOptions.find((opt) => opt.value === shape);
  return option ? option.label : shape;
};
</script>
<style lang="less" scoped></style>
